import React, { useMemo, useState, useEffect } from 'react';
import classNames from 'classnames';
import analyticsUtils from '../../../helpers/analytics-utils';
import trackEvent from '../../../helpers/analytics-utils/track-event';
import { toggleScroll } from '../.';
import style from './index.module.scss';
import { CentreSelector } from './centre-selector';
import { Nav } from './nav';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const lookupPath = (items, path) => {
  if (!items || !path.length) {
    return [];
  }

  const [key, ...rest] = path;
  const i = items.findIndex(item => (item === null || item === void 0 ? void 0 : item.key) === key);

  if (i === -1) {
    return [];
  }

  const item = items[i];
  return [i, ...lookupPath(item.items, rest)];
};

export const HamburgerMenu = ({
  country,
  centres,
  centre,
  shop,
  giftCards,
  initialPath,
  onClose,
  menuId
}) => {
  useEffect(() => () => toggleScroll(false), []);
  const findACentreNodes = useMemo(() => {
    if (!centres) {
      return undefined;
    }

    const centresByRegion = centres.reduce((acc, c) => {
      let arr = acc[c.state];

      if (!arr) {
        arr = [];
        acc[c.state] = arr;
      }

      arr.push(c);
      return acc;
    }, {});
    return [() => /*#__PURE__*/_jsx(CentreSelector, {
      centres: centres,
      centre: centre,
      onClose: onClose
    }), () => /*#__PURE__*/_jsx("div", {
      className: classNames(style.subtitle, style.regions),
      children: "Regions"
    }), ...(country === 'New Zealand' ? [['AUCKLAND', 'Auckland'], ['CHRISTCHURCH', 'Christchurch']] : [['ACT', 'Australian Capital Territory'], ['NSW', 'New South Wales'], ['QLD', 'Queensland'], ['SA', 'South Australia'], ['VIC', 'Victoria'], ['WA', 'Western Australia']]).filter(([key]) => centresByRegion[key]).map(([key, title]) => ({
      title,
      items: centresByRegion[key].sort((a, b) => a.title.localeCompare(b.title)).map(c => ({
        label: c.title,
        url: "/".concat(c.slug),
        onClick: onClose
      }))
    }))];
  }, [country, centres, centre]);
  const items = useMemo(() => {
    var _shop$navigationMenu;

    return [shop !== null && shop !== void 0 && (_shop$navigationMenu = shop.navigationMenu) !== null && _shop$navigationMenu !== void 0 && _shop$navigationMenu.length ? {
      key: 'shop',
      title: 'Shop online',
      items: shop.navigationMenu,
      className: classNames(style['item-big'])
    } : undefined, centre ? {
      key: 'centre',
      title: centre.title,
      hideTitle: true,
      items: [() => /*#__PURE__*/_jsxs("div", {
        className: classNames(style.item),
        children: [/*#__PURE__*/_jsx("div", {
          className: classNames(style.title),
          children: centre.title
        }), /*#__PURE__*/_jsx("button", {
          className: classNames(style.link),
          onClick: () => {
            setPath(lookupPath(items, ['find-a-centre']));
            trackEvent(analyticsUtils.categories.UNIVERSAL_HEADER, analyticsUtils.actions.UNIVERSAL_HEADER_NAV_MENU_OPEN, "Edit centre");
          },
          children: "Change"
        })]
      }), {
        key: 'Home',
        label: 'Home',
        url: "/".concat(centre.slug)
      }, ...centre.navigationMenu],
      className: classNames(style['item-big'])
    } : findACentreNodes && {
      key: 'find-a-centre',
      title: 'Find a centre',
      items: findACentreNodes,
      className: classNames(style['item-big'])
    }, giftCards && {
      key: 'gift-cards',
      title: 'Gift cards',
      items: giftCards,
      className: classNames(style['item-big'])
    }, ...(country === 'Australia' ? [{
      key: 'the-edit',
      label: 'The Edit',
      url: '/the-edit',
      className: classNames(style['item-big'])
    }] : []), centre && findACentreNodes && {
      key: 'find-a-centre',
      title: 'Find a centre',
      items: findACentreNodes
    }, {
      key: 'westfield-plus',
      label: 'Westfield Plus',
      url: '/westfield-plus',
      attrs: {
        target: '_blank',
        rel: 'noopener noreferrer'
      }
    }, {
      key: 'support',
      label: 'Customer Support',
      url: country === 'New Zealand' ? 'https://support.westfield.co.nz' : 'https://support.westfield.com.au'
    }];
  }, [country, centre, shop, giftCards, findACentreNodes]);
  const {
    0: path,
    1: setPath
  } = useState(() => initialPath ? lookupPath(items, initialPath.filter(Boolean)) : []);
  return /*#__PURE__*/_jsx(Nav, {
    menuId: menuId,
    items: items,
    initialPath: path,
    onClose: onClose
  });
};